import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";

// Lightweight confirmation before removing a media node from the markdown.
// Strings are passed in so the parent owns i18n.
const ConfirmDeleteDialog = ({
  open,
  type,
  onCancel,
  onConfirm,
  strings,
}) => {
  const body = type === "video" ? strings.videoBody : strings.imageBody;

  return (
    <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
      <DialogTitle>{strings.title}</DialogTitle>
      <DialogContent>
        <Typography variant="body2">{body}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>{strings.cancel}</Button>
        <Button
          onClick={onConfirm}
          color="error"
          variant="contained"
          autoFocus
        >
          {strings.confirm}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDeleteDialog;
